module.exports = __webpack_public_path__ + "img/SA.524c6dbe.png";